import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {Pagination} from 'react-bootstrap'
import {linkFinder} from '../../core/links'
import {matchMedia} from '../../core/browser'
import {loadTodoStream} from '../actions'
import i18n from '../i18n'
import TodoStrip from './TodoStrip'
import style from './TodoStream.less'

const PAGE_SIZE = 20

class TodoStream extends Component {
    static propTypes = {
    	stream: PropTypes.array.isRequired,
        range: PropTypes.object.isRequired
    }

    componentDidMount() {
        const {dispatch} = this.props

        this._interval = setInterval(() => {
            dispatch(loadTodoStream())
        }, 30 * 1000)
    }

    componentWillUnmount() {
        clearInterval(this._interval)
    }

    _paginate(selectedEvent) {
        const {dispatch} = this.props

        const pageActive = selectedEvent.eventKey
        const offset = (pageActive - 1) * PAGE_SIZE
        const limit = offset + PAGE_SIZE - 1

        dispatch(loadTodoStream({range: {offset, limit}}))
    }

    _navigate(event, path) {
        const {dispatch} = this.props

        event.preventDefault()

        if (event.ctrlKey || event.metaKey) {
            window.open(path, '_blank')
        } else {
            dispatch(push(path))
        }
    }

    render() {
    	const {dispatch, authenticated, stream, range, company} = this.props

        const pageCount = Math.ceil(range.count / PAGE_SIZE)
        const pageActive = Math.floor(range.offset / PAGE_SIZE) + 1

        const youHaveNoTodo = () => {
            if (company && company._links.find(linkFinder('workflows'))) {
                return i18n.youHaveNoTodoClickText.map((text, index) => {
                    if (index == 1) return (
                        <a
                            key={index}
                            href=''
                            onClick={(e) => this._navigate(e, '/organisations/' + company.uid + '/workflows')}>
                            {text}
                        </a>
                    )
                    return (<span key={index}>{text}</span>)
                })
            }
            return i18n.youHaveNoTodo
        }

        return (
            <div>
                {stream.map((todo, index) => (
                    <TodoStrip
                        key={index}
                        todo={todo}
                        authenticated={authenticated}
                        onClick={(e) => this._navigate(e, '/tickets/' + todo.ticket.uid)} />
                ))}
                {stream.length == 0 && (
                    <p className={style.noTodo}>
                        {youHaveNoTodo()}
                    </p>
                )}
                <div className={style.pagination}>
                    <Pagination
                        items={pageCount}
                        maxButtons={matchMedia('sm') && 5 || 4}
                        activePage={pageActive}
                        onSelect={(e, se) => this._paginate(se)}
                        prev next first last ellipsis />
                </div>
        	</div>
        )
    }
}

TodoStream = connect((state) => ({
    authenticated: state.user.authenticated,
    stream: state.workflow.todo.stream,
    range: state.workflow.todo.range,
    company: state.company.company
}))(TodoStream)

export default TodoStream


// WEBPACK FOOTER //
// ./lib/workflow/components/TodoStream.js